"use client";

import React, { createRef } from "react";
import Styles from "./NSBoxPhone.module.css";
import "./NSBoxPhone.module.css";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IValidationProps } from "../props/IValidationProps";
import { IValidationStringProps } from "../props/IValidationStringProps";
import { Validator } from "../Validator";
import { INSBoxBaseLayoutProps, NSBoxBaseLayout } from "./NSBoxBaseLayout";
import { safeMenuMenuItem } from "./NSMenuButton";
import { NamingConvention } from "namirasoft-core";
import { INSBox } from "./INSBox";

export interface NSBoxPhoneProps extends IBaseComponentProps, IValidationProps, IValidationStringProps, INSBoxBaseLayoutProps<NSBoxPhone, string>
{ }

export interface NSBoxPhoneState
{
	value: string | null;
}

export class NSBoxPhone extends React.Component<NSBoxPhoneProps, NSBoxPhoneState> implements INSBox
{
	NSBoxBaseLayout_Main = createRef<NSBoxBaseLayout>();
	constructor(props: NSBoxPhoneProps)
	{
		super(props);
		this.state = { value: props.defaultValue ?? null };
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
	}
	isEmpty(value: string)
	{
		if ((value ?? "").trim())
			return false;
		return true;
	}
	getError(): string | null
	{
		return (
			Validator.getError(this.props.title, this.state.value, this.props) ||
			Validator.getErrorString(this.props.title, this.state.value, this.props)
		);
	}
	getValue(checkError: boolean = true): string | null
	{
		return NSBoxBaseLayout.checkGetValue(this, checkError, () =>
		{
			let value = this.state.value?.trim();
			if (!value?.startsWith('+'))
				value = '+' + value;
			return value;
		});
	}
	setValue(value: string | null, callback?: () => void): void 
	{
		this.setState({ value }, () =>
		{
			this.props.onChanged?.(this);
			callback?.();
		});
	}
	override render()
	{
		let menu = safeMenuMenuItem(this.props, (items) =>
		{
			if (!this.getError())
				items.push({
					title: "Call",
					icon: "https://static.namirasoft.com/image/concept/type/phone.png",
					href: `tel:${this.state.value}`
				});
		});
		menu.builtin.copy = { enabled: true, getValue: () => this.state.value ?? "" };

		return (
			<NSBoxBaseLayout
				ref={this.NSBoxBaseLayout_Main}
				{...this.props}
				menu={menu}
			>
				<PhoneInput
					key={this.props.id}
					value={this.state.value}
					onChange={(value) => { this.setValue(value); }}
					onClick={() => { if (this.props.onClicked) this.props.onClicked(this); }}
					country={'us'}
					containerClass={Styles.ns_box_phone_container}
					inputClass={Styles.ns_box_phone_input}
					buttonClass={Styles.ns_box_phone_button}
					enableSearch={true}
					searchClass={Styles.ns_box_phone_search}
					dropdownClass={Styles.ns_box_phone_dropdown}
					placeholder={this.props.placeholder ?? `Please enter ${NamingConvention.auto.convert(this.props.title, NamingConvention.lower_case_space)}`}
					inputStyle={{
						background: `url("https://static.namirasoft.com/image/concept/type/phone.png") white no-repeat scroll center right 4px`,
						backgroundSize: "24px"
					}}
				/>
			</NSBoxBaseLayout>
		);
	}
}